export default __webpack_public_path__ + "static/media/404.29a745b5.jpg";